import { Image } from 'antd'
import styles from './LentaItem.module.css'
import { transform } from 'typescript'
export const ImageGroupPreview = ({images}:{images:string[]}) =>{
    return(
    <div className={styles.lenta_image_group_container}>
        <div className={styles.lenta_image_group_item} style={{maxHeight:images.length>2?"100px":"220px"}}>
            {images.length>0&&<Image src={images[0]}/>}
            {images.length>1&&<Image src={images[1]}/>}
        </div>
        <div className={styles.lenta_image_group_item} style={{maxHeight:images.length>2?"100px":"0px"}}>
            {images.length>2&&<Image src={images[2]}/>}
            {images.length>3&&<Image src={images[3]}/>}
        </div>
    </div>
    )
}